export default {"src":"/_next/static/media/disbursed.f06ddfdc.svg","height":50,"width":51};